import React from 'react';
import { Box } from '@mui/material';
import Nav from './Nav';
import Home from './Home';
import background from '../../images/bg.png';

const HeroSection = () => (
  <Box sx={{
    width: '100%', padding: { xs: '0 40px', sm: '0 100px' }, backgroundImage: `url(${background})`, height: { xs: '110vh', sm: '100vh' }, display: 'flex', flexDirection: 'column', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundAttachment: 'fixed',
  }}
  >
    <Nav />
    <Home />
  </Box>
);

export default HeroSection;
